import { cloneDeep, merge } from 'lodash'

import { TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { datePresets, getChosenDay } from '@/utils'

import tasksTemplate from '@/components/services/tasks/template'
import { tasksFilter } from '@/components/services/tasks/utils'

import render from './render'

const tasksDefaultFilter = merge(
  cloneDeep(tasksFilter),
  {
    type: 'sendings:bulk',
    data: {
      sending: {
        type: undefined
      }
    }
  }
)

export default {
  name: 'SendingsTasks',

  components: {
    'tasks-template': tasksTemplate({
      taskType: TaskTypes['sendings:bulk'],
      defaultFilter: tasksDefaultFilter,
      presets: [
        {
          title: 'today',
          filter: merge(
            cloneDeep(tasksDefaultFilter),
            {
              state: undefined,
              createdAt: {
                $gt: undefined,
                $lt: undefined
              },
              createdAtPreset: datePresets.today
            }
          )
        },
        {
          title: 'twoWeeks',
          filter: merge(
            cloneDeep(tasksDefaultFilter),
            {
              state: TaskStates.scheduled,
              createdAt: getChosenDay(-14),
              createdAtPreset: undefined
            }
          )
        }
      ]
    })
  },

  data() {
    return {
      showTasksInfo: false,
      dialogData: undefined
    }
  },

  render
}
